// This file is auto-generated by @hey-api/openapi-ts

import { type Options, mvpApiListProducts, mvpApiCreateNewProducts, mvpApiGetProduct, mvpApiSearchProducts, mvpApiUploadProductImage, mvpApiListPlanograms, mvpApiCreateNewPlanograms, mvpApiListUniquePlanogramDescriptions, mvpApiGetPlanogram, mvpApiUpdatePlanogram, mvpApiGetPlanogramSummary, mvpApiGetPlanogramProduct, mvpApiUploadPlanogramImage, mvpApiListStorePlanograms, mvpApiCreateNewStorePlanogram, mvpApiGetStorePlanogram, mvpApiUpdateStorePlanogram, mvpApiListSuppliers, mvpApiCreateNewSuppliers, mvpApiListRetailers, mvpApiGetRetailer, mvpApiListStores, mvpApiGetStore, mvpApiListPlanogramGroups, mvpApiCreateNewPlanogramGroup, mvpApiListPlanogramGroupsWithMissingProductImageCount, mvpApiListUniquePlanogramGroupNames, mvpApiGetPlanogramGroup, mvpApiUpdatePlanogramGroup, mvpApiListProductImages, mvpApiCreateProductIssue } from '../sdk.gen';
import { queryOptions, infiniteQueryOptions, type InfiniteData, type DefaultError, type UseMutationOptions } from '@tanstack/react-query';
import type { MvpApiListProductsData, MvpApiListProductsResponse, MvpApiCreateNewProductsData, MvpApiCreateNewProductsResponse, MvpApiGetProductData, MvpApiSearchProductsData, MvpApiSearchProductsResponse, MvpApiUploadProductImageData, MvpApiUploadProductImageResponse, MvpApiListPlanogramsData, MvpApiListPlanogramsResponse, MvpApiCreateNewPlanogramsData, MvpApiListUniquePlanogramDescriptionsData, MvpApiGetPlanogramData, MvpApiUpdatePlanogramData, MvpApiUpdatePlanogramResponse, MvpApiGetPlanogramSummaryData, MvpApiGetPlanogramProductData, MvpApiUploadPlanogramImageData, MvpApiListStorePlanogramsData, MvpApiListStorePlanogramsResponse, MvpApiCreateNewStorePlanogramData, MvpApiCreateNewStorePlanogramResponse, MvpApiGetStorePlanogramData, MvpApiUpdateStorePlanogramData, MvpApiUpdateStorePlanogramResponse, MvpApiListSuppliersData, MvpApiListSuppliersResponse, MvpApiCreateNewSuppliersData, MvpApiCreateNewSuppliersResponse, MvpApiListRetailersData, MvpApiListRetailersResponse, MvpApiGetRetailerData, MvpApiListStoresData, MvpApiListStoresResponse, MvpApiGetStoreData, MvpApiListPlanogramGroupsData, MvpApiListPlanogramGroupsResponse, MvpApiCreateNewPlanogramGroupData, MvpApiCreateNewPlanogramGroupResponse, MvpApiListPlanogramGroupsWithMissingProductImageCountData, MvpApiListUniquePlanogramGroupNamesData, MvpApiGetPlanogramGroupData, MvpApiUpdatePlanogramGroupData, MvpApiUpdatePlanogramGroupResponse, MvpApiListProductImagesData, MvpApiListProductImagesResponse, MvpApiCreateProductIssueData, MvpApiCreateProductIssueResponse } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const mvpApiListProductsQueryKey = (options?: Options<MvpApiListProductsData>) => createQueryKey('mvpApiListProducts', options);

/**
 * List Products
 */
export const mvpApiListProductsOptions = (options?: Options<MvpApiListProductsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListProducts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListProductsQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const mvpApiListProductsInfiniteQueryKey = (options?: Options<MvpApiListProductsData>): QueryKey<Options<MvpApiListProductsData>> => createQueryKey('mvpApiListProducts', options, true);

/**
 * List Products
 */
export const mvpApiListProductsInfiniteOptions = (options?: Options<MvpApiListProductsData>) => {
    return infiniteQueryOptions<MvpApiListProductsResponse, DefaultError, InfiniteData<MvpApiListProductsResponse>, QueryKey<Options<MvpApiListProductsData>>, number | Pick<QueryKey<Options<MvpApiListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListProducts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListProductsInfiniteQueryKey(options)
    });
};

export const mvpApiCreateNewProductsQueryKey = (options: Options<MvpApiCreateNewProductsData>) => createQueryKey('mvpApiCreateNewProducts', options);

/**
 * Create New Products
 */
export const mvpApiCreateNewProductsOptions = (options: Options<MvpApiCreateNewProductsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateNewProducts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateNewProductsQueryKey(options)
    });
};

/**
 * Create New Products
 */
export const mvpApiCreateNewProductsMutation = (options?: Partial<Options<MvpApiCreateNewProductsData>>): UseMutationOptions<MvpApiCreateNewProductsResponse, DefaultError, Options<MvpApiCreateNewProductsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewProductsResponse, DefaultError, Options<MvpApiCreateNewProductsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateNewProducts({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetProductQueryKey = (options: Options<MvpApiGetProductData>) => createQueryKey('mvpApiGetProduct', options);

/**
 * Get Product
 */
export const mvpApiGetProductOptions = (options: Options<MvpApiGetProductData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetProduct({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetProductQueryKey(options)
    });
};

export const mvpApiSearchProductsQueryKey = (options: Options<MvpApiSearchProductsData>) => createQueryKey('mvpApiSearchProducts', options);

/**
 * Search Products
 */
export const mvpApiSearchProductsOptions = (options: Options<MvpApiSearchProductsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiSearchProducts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiSearchProductsQueryKey(options)
    });
};

export const mvpApiSearchProductsInfiniteQueryKey = (options: Options<MvpApiSearchProductsData>): QueryKey<Options<MvpApiSearchProductsData>> => createQueryKey('mvpApiSearchProducts', options, true);

/**
 * Search Products
 */
export const mvpApiSearchProductsInfiniteOptions = (options: Options<MvpApiSearchProductsData>) => {
    return infiniteQueryOptions<MvpApiSearchProductsResponse, DefaultError, InfiniteData<MvpApiSearchProductsResponse>, QueryKey<Options<MvpApiSearchProductsData>>, number | Pick<QueryKey<Options<MvpApiSearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiSearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiSearchProducts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiSearchProductsInfiniteQueryKey(options)
    });
};

export const mvpApiUploadProductImageQueryKey = (options: Options<MvpApiUploadProductImageData>) => createQueryKey('mvpApiUploadProductImage', options);

/**
 * Upload Product Image
 */
export const mvpApiUploadProductImageOptions = (options: Options<MvpApiUploadProductImageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiUploadProductImage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiUploadProductImageQueryKey(options)
    });
};

/**
 * Upload Product Image
 */
export const mvpApiUploadProductImageMutation = (options?: Partial<Options<MvpApiUploadProductImageData>>): UseMutationOptions<MvpApiUploadProductImageResponse, DefaultError, Options<MvpApiUploadProductImageData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUploadProductImageResponse, DefaultError, Options<MvpApiUploadProductImageData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUploadProductImage({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListPlanogramsQueryKey = (options?: Options<MvpApiListPlanogramsData>) => createQueryKey('mvpApiListPlanograms', options);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsOptions = (options?: Options<MvpApiListPlanogramsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListPlanograms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramsQueryKey(options)
    });
};

export const mvpApiListPlanogramsInfiniteQueryKey = (options?: Options<MvpApiListPlanogramsData>): QueryKey<Options<MvpApiListPlanogramsData>> => createQueryKey('mvpApiListPlanograms', options, true);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsInfiniteOptions = (options?: Options<MvpApiListPlanogramsData>) => {
    return infiniteQueryOptions<MvpApiListPlanogramsResponse, DefaultError, InfiniteData<MvpApiListPlanogramsResponse>, QueryKey<Options<MvpApiListPlanogramsData>>, number | Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListPlanograms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramsInfiniteQueryKey(options)
    });
};

export const mvpApiCreateNewPlanogramsQueryKey = (options: Options<MvpApiCreateNewPlanogramsData>) => createQueryKey('mvpApiCreateNewPlanograms', options);

/**
 * Create New Planograms
 */
export const mvpApiCreateNewPlanogramsOptions = (options: Options<MvpApiCreateNewPlanogramsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateNewPlanograms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateNewPlanogramsQueryKey(options)
    });
};

/**
 * Create New Planograms
 */
export const mvpApiCreateNewPlanogramsMutation = (options?: Partial<Options<MvpApiCreateNewPlanogramsData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateNewPlanogramsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateNewPlanogramsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateNewPlanograms({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListUniquePlanogramDescriptionsQueryKey = (options?: Options<MvpApiListUniquePlanogramDescriptionsData>) => createQueryKey('mvpApiListUniquePlanogramDescriptions', options);

/**
 * List Unique Planogram Descriptions
 */
export const mvpApiListUniquePlanogramDescriptionsOptions = (options?: Options<MvpApiListUniquePlanogramDescriptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListUniquePlanogramDescriptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListUniquePlanogramDescriptionsQueryKey(options)
    });
};

export const mvpApiGetPlanogramQueryKey = (options: Options<MvpApiGetPlanogramData>) => createQueryKey('mvpApiGetPlanogram', options);

/**
 * Get Planogram
 */
export const mvpApiGetPlanogramOptions = (options: Options<MvpApiGetPlanogramData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetPlanogram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetPlanogramQueryKey(options)
    });
};

/**
 * Update Planogram
 */
export const mvpApiUpdatePlanogramMutation = (options?: Partial<Options<MvpApiUpdatePlanogramData>>): UseMutationOptions<MvpApiUpdatePlanogramResponse, DefaultError, Options<MvpApiUpdatePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdatePlanogramResponse, DefaultError, Options<MvpApiUpdatePlanogramData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdatePlanogram({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetPlanogramSummaryQueryKey = (options: Options<MvpApiGetPlanogramSummaryData>) => createQueryKey('mvpApiGetPlanogramSummary', options);

/**
 * Get Planogram Summary
 */
export const mvpApiGetPlanogramSummaryOptions = (options: Options<MvpApiGetPlanogramSummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetPlanogramSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetPlanogramSummaryQueryKey(options)
    });
};

export const mvpApiGetPlanogramProductQueryKey = (options: Options<MvpApiGetPlanogramProductData>) => createQueryKey('mvpApiGetPlanogramProduct', options);

/**
 * Get Planogram Product
 */
export const mvpApiGetPlanogramProductOptions = (options: Options<MvpApiGetPlanogramProductData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetPlanogramProduct({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetPlanogramProductQueryKey(options)
    });
};

export const mvpApiUploadPlanogramImageQueryKey = (options: Options<MvpApiUploadPlanogramImageData>) => createQueryKey('mvpApiUploadPlanogramImage', options);

/**
 * Upload Planogram Image
 */
export const mvpApiUploadPlanogramImageOptions = (options: Options<MvpApiUploadPlanogramImageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiUploadPlanogramImage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiUploadPlanogramImageQueryKey(options)
    });
};

/**
 * Upload Planogram Image
 */
export const mvpApiUploadPlanogramImageMutation = (options?: Partial<Options<MvpApiUploadPlanogramImageData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiUploadPlanogramImageData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiUploadPlanogramImageData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUploadPlanogramImage({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListStorePlanogramsQueryKey = (options?: Options<MvpApiListStorePlanogramsData>) => createQueryKey('mvpApiListStorePlanograms', options);

/**
 * List Store Planograms
 */
export const mvpApiListStorePlanogramsOptions = (options?: Options<MvpApiListStorePlanogramsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListStorePlanograms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListStorePlanogramsQueryKey(options)
    });
};

export const mvpApiListStorePlanogramsInfiniteQueryKey = (options?: Options<MvpApiListStorePlanogramsData>): QueryKey<Options<MvpApiListStorePlanogramsData>> => createQueryKey('mvpApiListStorePlanograms', options, true);

/**
 * List Store Planograms
 */
export const mvpApiListStorePlanogramsInfiniteOptions = (options?: Options<MvpApiListStorePlanogramsData>) => {
    return infiniteQueryOptions<MvpApiListStorePlanogramsResponse, DefaultError, InfiniteData<MvpApiListStorePlanogramsResponse>, QueryKey<Options<MvpApiListStorePlanogramsData>>, number | Pick<QueryKey<Options<MvpApiListStorePlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListStorePlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListStorePlanograms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListStorePlanogramsInfiniteQueryKey(options)
    });
};

export const mvpApiCreateNewStorePlanogramQueryKey = (options: Options<MvpApiCreateNewStorePlanogramData>) => createQueryKey('mvpApiCreateNewStorePlanogram', options);

/**
 * Create New Store Planogram
 */
export const mvpApiCreateNewStorePlanogramOptions = (options: Options<MvpApiCreateNewStorePlanogramData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateNewStorePlanogram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateNewStorePlanogramQueryKey(options)
    });
};

/**
 * Create New Store Planogram
 */
export const mvpApiCreateNewStorePlanogramMutation = (options?: Partial<Options<MvpApiCreateNewStorePlanogramData>>): UseMutationOptions<MvpApiCreateNewStorePlanogramResponse, DefaultError, Options<MvpApiCreateNewStorePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewStorePlanogramResponse, DefaultError, Options<MvpApiCreateNewStorePlanogramData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateNewStorePlanogram({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetStorePlanogramQueryKey = (options: Options<MvpApiGetStorePlanogramData>) => createQueryKey('mvpApiGetStorePlanogram', options);

/**
 * Get Store Planogram
 */
export const mvpApiGetStorePlanogramOptions = (options: Options<MvpApiGetStorePlanogramData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetStorePlanogram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetStorePlanogramQueryKey(options)
    });
};

/**
 * Update Store Planogram
 */
export const mvpApiUpdateStorePlanogramMutation = (options?: Partial<Options<MvpApiUpdateStorePlanogramData>>): UseMutationOptions<MvpApiUpdateStorePlanogramResponse, DefaultError, Options<MvpApiUpdateStorePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateStorePlanogramResponse, DefaultError, Options<MvpApiUpdateStorePlanogramData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateStorePlanogram({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListSuppliersQueryKey = (options?: Options<MvpApiListSuppliersData>) => createQueryKey('mvpApiListSuppliers', options);

/**
 * List Suppliers
 */
export const mvpApiListSuppliersOptions = (options?: Options<MvpApiListSuppliersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListSuppliers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListSuppliersQueryKey(options)
    });
};

export const mvpApiListSuppliersInfiniteQueryKey = (options?: Options<MvpApiListSuppliersData>): QueryKey<Options<MvpApiListSuppliersData>> => createQueryKey('mvpApiListSuppliers', options, true);

/**
 * List Suppliers
 */
export const mvpApiListSuppliersInfiniteOptions = (options?: Options<MvpApiListSuppliersData>) => {
    return infiniteQueryOptions<MvpApiListSuppliersResponse, DefaultError, InfiniteData<MvpApiListSuppliersResponse>, QueryKey<Options<MvpApiListSuppliersData>>, number | Pick<QueryKey<Options<MvpApiListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListSuppliers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListSuppliersInfiniteQueryKey(options)
    });
};

export const mvpApiCreateNewSuppliersQueryKey = (options: Options<MvpApiCreateNewSuppliersData>) => createQueryKey('mvpApiCreateNewSuppliers', options);

/**
 * Create New Suppliers
 */
export const mvpApiCreateNewSuppliersOptions = (options: Options<MvpApiCreateNewSuppliersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateNewSuppliers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateNewSuppliersQueryKey(options)
    });
};

/**
 * Create New Suppliers
 */
export const mvpApiCreateNewSuppliersMutation = (options?: Partial<Options<MvpApiCreateNewSuppliersData>>): UseMutationOptions<MvpApiCreateNewSuppliersResponse, DefaultError, Options<MvpApiCreateNewSuppliersData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewSuppliersResponse, DefaultError, Options<MvpApiCreateNewSuppliersData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateNewSuppliers({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListRetailersQueryKey = (options?: Options<MvpApiListRetailersData>) => createQueryKey('mvpApiListRetailers', options);

/**
 * List Retailers
 */
export const mvpApiListRetailersOptions = (options?: Options<MvpApiListRetailersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListRetailers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListRetailersQueryKey(options)
    });
};

export const mvpApiListRetailersInfiniteQueryKey = (options?: Options<MvpApiListRetailersData>): QueryKey<Options<MvpApiListRetailersData>> => createQueryKey('mvpApiListRetailers', options, true);

/**
 * List Retailers
 */
export const mvpApiListRetailersInfiniteOptions = (options?: Options<MvpApiListRetailersData>) => {
    return infiniteQueryOptions<MvpApiListRetailersResponse, DefaultError, InfiniteData<MvpApiListRetailersResponse>, QueryKey<Options<MvpApiListRetailersData>>, number | Pick<QueryKey<Options<MvpApiListRetailersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListRetailersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListRetailers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListRetailersInfiniteQueryKey(options)
    });
};

export const mvpApiGetRetailerQueryKey = (options: Options<MvpApiGetRetailerData>) => createQueryKey('mvpApiGetRetailer', options);

/**
 * Get Retailer
 */
export const mvpApiGetRetailerOptions = (options: Options<MvpApiGetRetailerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetRetailer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetRetailerQueryKey(options)
    });
};

export const mvpApiListStoresQueryKey = (options?: Options<MvpApiListStoresData>) => createQueryKey('mvpApiListStores', options);

/**
 * List Stores
 */
export const mvpApiListStoresOptions = (options?: Options<MvpApiListStoresData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListStores({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListStoresQueryKey(options)
    });
};

export const mvpApiListStoresInfiniteQueryKey = (options?: Options<MvpApiListStoresData>): QueryKey<Options<MvpApiListStoresData>> => createQueryKey('mvpApiListStores', options, true);

/**
 * List Stores
 */
export const mvpApiListStoresInfiniteOptions = (options?: Options<MvpApiListStoresData>) => {
    return infiniteQueryOptions<MvpApiListStoresResponse, DefaultError, InfiniteData<MvpApiListStoresResponse>, QueryKey<Options<MvpApiListStoresData>>, number | Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListStores({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListStoresInfiniteQueryKey(options)
    });
};

export const mvpApiGetStoreQueryKey = (options: Options<MvpApiGetStoreData>) => createQueryKey('mvpApiGetStore', options);

/**
 * Get Store
 */
export const mvpApiGetStoreOptions = (options: Options<MvpApiGetStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetStoreQueryKey(options)
    });
};

export const mvpApiListPlanogramGroupsQueryKey = (options?: Options<MvpApiListPlanogramGroupsData>) => createQueryKey('mvpApiListPlanogramGroups', options);

/**
 * List Planogram Groups
 */
export const mvpApiListPlanogramGroupsOptions = (options?: Options<MvpApiListPlanogramGroupsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListPlanogramGroups({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramGroupsQueryKey(options)
    });
};

export const mvpApiListPlanogramGroupsInfiniteQueryKey = (options?: Options<MvpApiListPlanogramGroupsData>): QueryKey<Options<MvpApiListPlanogramGroupsData>> => createQueryKey('mvpApiListPlanogramGroups', options, true);

/**
 * List Planogram Groups
 */
export const mvpApiListPlanogramGroupsInfiniteOptions = (options?: Options<MvpApiListPlanogramGroupsData>) => {
    return infiniteQueryOptions<MvpApiListPlanogramGroupsResponse, DefaultError, InfiniteData<MvpApiListPlanogramGroupsResponse>, QueryKey<Options<MvpApiListPlanogramGroupsData>>, number | Pick<QueryKey<Options<MvpApiListPlanogramGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListPlanogramGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListPlanogramGroups({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramGroupsInfiniteQueryKey(options)
    });
};

export const mvpApiCreateNewPlanogramGroupQueryKey = (options: Options<MvpApiCreateNewPlanogramGroupData>) => createQueryKey('mvpApiCreateNewPlanogramGroup', options);

/**
 * Create New Planogram Group
 */
export const mvpApiCreateNewPlanogramGroupOptions = (options: Options<MvpApiCreateNewPlanogramGroupData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateNewPlanogramGroup({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateNewPlanogramGroupQueryKey(options)
    });
};

/**
 * Create New Planogram Group
 */
export const mvpApiCreateNewPlanogramGroupMutation = (options?: Partial<Options<MvpApiCreateNewPlanogramGroupData>>): UseMutationOptions<MvpApiCreateNewPlanogramGroupResponse, DefaultError, Options<MvpApiCreateNewPlanogramGroupData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewPlanogramGroupResponse, DefaultError, Options<MvpApiCreateNewPlanogramGroupData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateNewPlanogramGroup({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListPlanogramGroupsWithMissingProductImageCountQueryKey = (options?: Options<MvpApiListPlanogramGroupsWithMissingProductImageCountData>) => createQueryKey('mvpApiListPlanogramGroupsWithMissingProductImageCount', options);

/**
 * List Planogram Groups With Missing Product Image Count
 * Get all planogram groups with their missing image counts in a single query.
 * Returns a list of dictionaries with id, name, missing_product_image_count, and total_product_count.
 *
 * [
 * { "id": "...", "name": "SKINCARE, DRY", "missing_product_image_count": 26, "total_product_count": 455 },
 * { "id": "...", "name": "HAIRCARE, COLOURS", "missing_product_image_count": 24, "total_product_count": 418 },
 * ...
 * ]
 */
export const mvpApiListPlanogramGroupsWithMissingProductImageCountOptions = (options?: Options<MvpApiListPlanogramGroupsWithMissingProductImageCountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListPlanogramGroupsWithMissingProductImageCount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramGroupsWithMissingProductImageCountQueryKey(options)
    });
};

export const mvpApiListUniquePlanogramGroupNamesQueryKey = (options?: Options<MvpApiListUniquePlanogramGroupNamesData>) => createQueryKey('mvpApiListUniquePlanogramGroupNames', options);

/**
 * List Unique Planogram Group Names
 */
export const mvpApiListUniquePlanogramGroupNamesOptions = (options?: Options<MvpApiListUniquePlanogramGroupNamesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListUniquePlanogramGroupNames({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListUniquePlanogramGroupNamesQueryKey(options)
    });
};

export const mvpApiGetPlanogramGroupQueryKey = (options: Options<MvpApiGetPlanogramGroupData>) => createQueryKey('mvpApiGetPlanogramGroup', options);

/**
 * Get Planogram Group
 */
export const mvpApiGetPlanogramGroupOptions = (options: Options<MvpApiGetPlanogramGroupData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetPlanogramGroup({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetPlanogramGroupQueryKey(options)
    });
};

/**
 * Update Planogram Group
 */
export const mvpApiUpdatePlanogramGroupMutation = (options?: Partial<Options<MvpApiUpdatePlanogramGroupData>>): UseMutationOptions<MvpApiUpdatePlanogramGroupResponse, DefaultError, Options<MvpApiUpdatePlanogramGroupData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdatePlanogramGroupResponse, DefaultError, Options<MvpApiUpdatePlanogramGroupData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdatePlanogramGroup({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListProductImagesQueryKey = (options?: Options<MvpApiListProductImagesData>) => createQueryKey('mvpApiListProductImages', options);

/**
 * List Product Images
 */
export const mvpApiListProductImagesOptions = (options?: Options<MvpApiListProductImagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListProductImages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListProductImagesQueryKey(options)
    });
};

export const mvpApiListProductImagesInfiniteQueryKey = (options?: Options<MvpApiListProductImagesData>): QueryKey<Options<MvpApiListProductImagesData>> => createQueryKey('mvpApiListProductImages', options, true);

/**
 * List Product Images
 */
export const mvpApiListProductImagesInfiniteOptions = (options?: Options<MvpApiListProductImagesData>) => {
    return infiniteQueryOptions<MvpApiListProductImagesResponse, DefaultError, InfiniteData<MvpApiListProductImagesResponse>, QueryKey<Options<MvpApiListProductImagesData>>, number | Pick<QueryKey<Options<MvpApiListProductImagesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListProductImagesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListProductImages({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListProductImagesInfiniteQueryKey(options)
    });
};

export const mvpApiCreateProductIssueQueryKey = (options: Options<MvpApiCreateProductIssueData>) => createQueryKey('mvpApiCreateProductIssue', options);

/**
 * Create Product Issue
 */
export const mvpApiCreateProductIssueOptions = (options: Options<MvpApiCreateProductIssueData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateProductIssue({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateProductIssueQueryKey(options)
    });
};

/**
 * Create Product Issue
 */
export const mvpApiCreateProductIssueMutation = (options?: Partial<Options<MvpApiCreateProductIssueData>>): UseMutationOptions<MvpApiCreateProductIssueResponse, DefaultError, Options<MvpApiCreateProductIssueData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateProductIssueResponse, DefaultError, Options<MvpApiCreateProductIssueData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateProductIssue({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};